<template>
    <!-- Tamanho do texto do site (A−, A, A+): a escolha fica guardada e vale em todas as páginas. -->
    <div class="flex items-center gap-1.5 text-xs sm:text-sm text-black" role="group" aria-labelledby="rotulo_tamanho_texto">
        <span id="rotulo_tamanho_texto" class="flex items-center gap-1 font-semibold whitespace-nowrap">
            <Accessibility class="w-4 h-4" aria-hidden="true" /> Acessibilidade
        </span>
        <button type="button" class="botao" :disabled="!podeDiminuir" aria-label="Diminuir o tamanho do texto" title="Diminuir texto" @click="decreaseFont">A−</button>
        <button type="button" class="botao" aria-label="Voltar ao tamanho padrão do texto" title="Tamanho padrão" @click="resetFont">A</button>
        <button type="button" class="botao" :disabled="!podeAumentar" aria-label="Aumentar o tamanho do texto" title="Aumentar texto" @click="increaseFont">A+</button>
    </div>
</template>

<script setup>
import { Accessibility } from 'lucide-vue-next'
import { useFontScale } from '../../../composables/useFontScale'

const { increaseFont, decreaseFont, resetFont, podeAumentar, podeDiminuir } = useFontScale()
</script>

<style scoped>
.botao {
    @apply inline-flex items-center justify-center min-w-[2rem] h-7 px-1.5 rounded-md border border-black/60 bg-white/40 font-bold text-black hover:bg-black hover:text-yellow-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-1 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-white/40 disabled:hover:text-black transition-colors;
}
</style>
